import { z } from "zod"

import { PricingNumericTypeValues } from "../constants"

export const warehouseHeaderFormSchema = z.object({
  desiredAcceptedCostChange: z.number().nullable(),
  acceptedCostChangeMode: z.nativeEnum(PricingNumericTypeValues),
  newAcceptedCost: z.number().nullable(),
  desiredPriceChange: z.number().nullable(),
  priceChangeMode: z.nativeEnum(PricingNumericTypeValues),
  maintainMargin: z.boolean().optional(),
})

export type WarehouseHeaderFormValues = z.infer<typeof warehouseHeaderFormSchema>
